import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

import GoogleFontLogo from 'components/tools/GoogleFontLogo';

import useGroup from 'hooks/useGroup';
import useConfig from 'hooks/useConfig';
import useColor from 'hooks/useColor';

import Urls from 'configs/urls';

import MarginWidthImage from 'assets/images/width-margin.png';
import MarginHeightImage from 'assets/images/height-margin.png';

import Form from 'components/Form/Form';

let updatePropsToChangeEstimate = false;

function OptionText(props) {
	const {
		group = false,
		type = false,
		components = {}
	} = props;
	const {t} = useTranslation();

	const {
		fontFamilies
	} = useConfig();

	const [name, setName] = useState("");
	const [text, setText] = useState("");
	const [font, setFont] = useState(fontFamilies[0]);
	const [colorText, setColorText] = useState(false);
	const [colorBg, setColorBg] = useState(false);
	const [size, setSize] = useState('normal');
	const [marginWidth, setMarginWidth] = useState(0);
	const [marginHeight, setMarginHeight] = useState(0);


	const [width, setWidth] = useState(false);
	const [height, setHeight] = useState(false);
	const [maxWidth, setMaxWidth] = useState(false);
	const [maxHeight, setMaxHeight] = useState(false);


	const {
		estimate,
		fetchingEstimate,
		estimateGroup
	} = useGroup();

	const {
		colors
	} = useColor();

	useEffect(() => {
		if (group !== false && group.config) {
			setText(group.config.text);
			setFont(group.config.font);
			setColorText(group.config.colorText);
			setColorBg(group.config.colorBg);
			setSize(group.config.size);

			if (group.name) {
				setName(group.name);
			}
			if (group.config.marginWidth) {
				setMarginWidth(group.config.marginWidth);
			}

			if (group.config.marginHeight) {
				setMarginHeight(group.config.marginHeight);
			}

			if (group.config.maxHeight) {
				setMaxHeight(group.config.maxHeight);
			}

			if (group.config.maxWidth) {
				setMaxWidth(group.config.maxWidth);
			}


			if (width !== group.config.width) {
				setWidth(group.config.width);
			}

			if (height !== group.config.height) {
				setHeight(group.config.height);
			}
		} else {
			setText("");
			setName("");
			setMarginWidth(0);
			setMarginHeight(0);
		}
	}, [group]);


	useEffect(() => {
		if (fetchingEstimate) {
			return;
		}
		if (maxWidth === false && estimate.width !== false) {
			if (estimate.width !== maxWidth) {
				setMaxWidth(estimate.width);
			}
			if (estimate.width !== width) {
				setWidth(estimate.width);
			}
		}
		if (maxHeight === false && estimate.height !== false) {
			if (estimate.height !== maxHeight) {
				setMaxHeight(estimate.height);
			}
			if (estimate.height !== height) {
				setHeight(estimate.height);
			}
		}
	}, [estimate]);


	useEffect(() => {
		if (
			text &&
			type !== false &&
			font !== false &&
			colorText !== false &&
			colorBg !== false &&
			size !== false &&
			marginHeight !== false &&
			marginWidth !== false
		) {
			let completeParams = {
				width,
				height,
			}
			if (updatePropsToChangeEstimate) {
				setMaxHeight(false);
				setMaxWidth(false);
				completeParams = {};
			}

			let params = {
				type,
				text,
				font,
				colorBg,
				colorText,
				size,
				marginHeight,
				marginWidth,
				...completeParams,
				estimation: true
			};
			updatePropsToChangeEstimate = false;

			estimateGroup(params);
		}
	}, [
		text,
		type,
		font,
		colorText,
		colorBg,
		size,
		marginHeight,
		marginWidth,
		width,
		height
	]);

	const generate = () => {
		if (parseInt(type, 10) !== 1) {
			return;
		}
		if (name.trim() === '') {
			return alert(t('ModalAddGroup.errors.nameMissing'));
		}

		if (text.trim() === '') {
			return alert(t('OptionGroup.errors.textMissing'));
		}

		if (colorText === false) {
			return alert(t('OptionGroup.errors.colorTextMissing'));
		}

		if (colorBg === false) {
			return alert(t('OptionGroup.errors.colorBgMissing'));
		}

		let params = {
			type,
			text,
			font,
			colorBg,
			colorText,
			size,
			marginHeight,
			marginWidth,
			width,
			height,
			maxWidth,
			maxHeight
		};
		props.generate(params);
	}

	//TODO MARGIN MAX
	const checkMarginValue = (method, value) => {
		value = value.replace(/[^0-9.]/g, '');
		value = parseInt(value, 10);
		if (value > 20) {
			value = 20;
		}
		method(value);
	}

	let fontFamiliesOption = fontFamilies.map((family) => {
		return {
			value: family,
			label: family
		};
	});

	let textPreview = t('ModalAddGroup.yourText');
	if (text) {
		textPreview = text;
	}


	let colorCodesText = [];
	colors.map((c) => {
		if (colorBg !== c.color) {
			return colorCodesText.push(c.color);
		}
	});
	let colorCodesBg = [];
	colors.map((c) => {
		if (colorText !== c.color) {
			return colorCodesBg.push(c.color);
		}
	});


	return (
		<div className="row">

			<div className="col-12">
				<div className="mb-3" key="block6">
					<img
						className="preview-image-text"
						src={
							Urls.basePreviewText
								.replace(':font', font)
								.replace(':text', textPreview)
								.replace(':marginHeight', marginHeight)
								.replace(':marginWidth', marginWidth)
								.replace(':colorText', colorText === false ? '000000' : colorText.replace('#', ''))
								.replace(':colorBg', colorBg === false ? 'FFFFFF' : colorBg.replace('#', ''))
						}
					/>
				</div>
			</div>
			<div className="col-8">
				<Form
					hideBtn={true}
					injectData={{
						item: {
							fetching: false,
							loaded: true,
							props: {
								name,
								type,
								text,
								font,
								colorBg,
								colorText,
								size,
								marginHeight,
								marginWidth,
								width,
								height
							}
						},
						launchMethod: (method, params) => {

							if (method === 'change') {
								let values = params[0];
								if (typeof values.name !== 'undefined') {
									setName(values.name);
								}
								if (typeof values.text !== 'undefined' && text !== values.text) {
									setText(values.text);
									updatePropsToChangeEstimate = true;
								}
								if (typeof values.font !== 'undefined' && font !== values.font) {
									setFont(values.font);
									updatePropsToChangeEstimate = true;
								}

								if (typeof values.colorText !== 'undefined') {
									setColorText(values.colorText);
								}
								if (typeof values.colorBg !== 'undefined') {
									setColorBg(values.colorBg);
								}

								if (typeof values.marginHeight !== 'undefined' && values.marginHeight !== marginHeight) {
									setMarginHeight(values.marginHeight);
									updatePropsToChangeEstimate = true;
								}
								if (typeof values.marginWidth !== 'undefined' && values.marginWidth !== marginWidth) {
									setMarginWidth(values.marginWidth);
									updatePropsToChangeEstimate = true;
								}
								if (fetchingEstimate === false) {
									if (width && typeof values.width !== 'undefined' && values.width !== false && values.width !== width) {
										setWidth(values.width);
										let ratio = maxHeight / maxWidth;
										let newHeight = parseInt(ratio * values.width, 10);
										setHeight(newHeight);
									}
									if (height && typeof values.height !== 'undefined' && values.height !== false && values.height !== height) {
										setHeight(values.height);
										let ratio = maxWidth / maxHeight;
										setWidth(parseInt(ratio * values.height, 10));
									}
								}
							}
						}
					}}
					inputs={[
						{
							label: t('ModalAddGroup.form.labels.name'),
							name: 'name',
							required: true
						},
						{
							type: 'slider',
							label: t('OptionText.width'),
							name: 'width',
							required: true,
							min: maxWidth !== false ? parseInt(maxWidth / 4, 10) : false,
							max: maxWidth,
							value: width,
							hide: estimate && estimate.width === false
						},
						{
							type: 'slider',
							label: t('OptionText.height'),
							name: 'height',
							required: true,
							min: maxHeight !== false ? parseInt(maxHeight / 4, 10) : false,
							max: maxHeight,
							value: height,
							hide: estimate && estimate.height === false
						},
						{
							label: t('ModalAddGroup.form.labels.text'),
							name: 'text',
							required: true
						},
						{
							label: t('ModalAddGroup.form.labels.margins'),
							name: 'group',
							type: 'group',
							items: [
								{
									label: t('ModalAddGroup.form.placeholder.nbrDomino'),
									name: 'marginHeight',
									required: true,
									img: (MarginHeightImage),
									display: {
										label: false
									}
								},
								{
									label: t('ModalAddGroup.form.placeholder.nbrDomino'),
									name: 'marginWidth',
									required: true,
									img: (MarginWidthImage),
									display: {
										label: false
									}
								},
							]
						},
						{
							label: t('ModalAddGroup.form.labels.font'),
							name: 'font',
							type: 'select',
							options: fontFamiliesOption,
							required: true,
							components: {
								footer: (
									<GoogleFontLogo />
								)
							}
						},
						{
							label: t('OptionText.colors'),
							name: 'group',
							type: 'group',
							items: [
								{
									label: t('ModalAddGroup.form.labels.colorText'),
									name: 'colorText',
									type: 'colorlist',
									required: true,
									colors: colorCodesText
								},
								{
									label: t('ModalAddGroup.form.labels.colorBg'),
									name: 'colorBg',
									type: 'colorlist',
									required: true,
									colors: colorCodesBg
								},
							]
						}
					]}
				/>
			</div>
			<div className="col-4">

				{components.estimate}
				<div key="block7">
					<button
						type="button"
						className="btn btn-primary mb-1"
						onClick={generate}
					>
						{props.nameBtn}
					</button>
				</div>
			</div>
		</div>
	);
}

export default OptionText;
